import type { CityConfig } from "@/pages/city-template/types";

export const watertownConfig: CityConfig = {
  city: "Watertown",
  state: "New York",
  stateAbbr: "NY",
  slug: "watertown",
  route: "/cities/watertown",
  title: "Emergency & Expedited Passport Watertown NY | Same Day Passport Watertown",
  metaDescription:
    "Emergency passport Watertown NY — same day, 24-hour, and 3-5 day expedited passport processing for Jefferson County. Fast Passport Center serves Watertown, Fort Drum, Carthage, and all Thousand Islands region communities.",
  h1: "Emergency & Expedited Passport Services in Watertown, NY",
  heroSubtitle:
    "Watertown's fast passport solution — from the Thousand Islands to Fort Drum. Whether you're flying out of Watertown International or Syracuse Hancock, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Watertown%20New%20York%20downtown%20with%20historic%20Public%20Square%2C%20Thousand%20Islands%20region%20in%20background%2C%20Black%20River%20flowing%20through%20city%2C%20green%20summer%20landscape%2C%20warm%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20scenic%20North%20Country%20upstate%20New%20York%20cityscape%20with%20river%20and%20historic%20architecture&width=1600&height=700&seq=ny-watertown-hero-001&orientation=landscape",
  heroImageAlt: "Watertown New York downtown with Public Square and Black River",
  geoPosition: "43.9748; -75.9108",
  geoPlacename: "Watertown, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~280 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Watertown", zips: "13601, 13602, 13603" },
    { name: "Fort Drum", zips: "13602, 13603" },
    { name: "Carthage", zips: "13619" },
    { name: "Adams", zips: "13605, 13606" },
    { name: "Sackets Harbor", zips: "13685" },
    { name: "Copenhagen", zips: "13626" },
    { name: "Canton", zips: "13617" },
    { name: "Potsdam", zips: "13676, 13699" },
    { name: "Ogdensburg", zips: "13669" },
    { name: "Syracuse", zips: "13201-13210, 13211, 13212, 13214, 13215, 13217, 13218, 13219, 13220, 13224, 13225, 13235, 13244, 13250, 13251, 13252, 13261, 13290" },
    { name: "Rome", zips: "13440, 13441, 13442, 13449" },
    { name: "Utica", zips: "13501, 13502, 13503, 13504, 13505, 13599" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230-12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Watertown travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Watertown residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Jefferson & Thousand Islands Region",
      desc: "Watertown, Fort Drum, Carthage, and the entire Thousand Islands region — we serve all of northern New York from the St. Lawrence to the Adirondacks.",
    },
  ],
  testimonials: [
    {
      name: "Michael S.",
      location: "Fort Drum, NY",
      rating: 5,
      text: "As a military family at Fort Drum, we needed emergency passports for a sudden overseas reassignment. Fast Passport Center delivered in 3 days. They understand the urgency military families face.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa W.",
      location: "Watertown, NY",
      rating: 5,
      text: "Renewed my passport for a cruise through the Thousand Islands. The 5-day service was perfect. Fast Passport Center made the whole process easy from start to finish.",
      service: "Passport Renewal",
    },
    {
      name: "David C.",
      location: "Carthage, NY",
      rating: 5,
      text: "First-time passport for my son joining the military. The agent helped us through every step at the Watertown post office. Processed in 5 days with no issues.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "watertown-1",
      name: "Watertown Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "232 Washington Street",
      city: "Watertown",
      state: "NY",
      zip: "13601",
      phone: "315-782-6540",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Downtown Watertown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Watertown passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "watertown-2",
      name: "Fort Drum Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "11030 Mount Belvedere Boulevard",
      city: "Fort Drum",
      state: "NY",
      zip: "13602",
      phone: "315-772-6544",
      hours: "Mon-Fri 9:00 AM - 4:00 PM",
      distance: "Fort Drum (east of Watertown)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available for military personnel and families at Fort Drum. ID required for base access.",
      icon: "ri-building-2-line",
    },
    {
      id: "watertown-3",
      name: "Carthage Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "525 State Street",
      city: "Carthage",
      state: "NY",
      zip: "13619",
      phone: "315-493-2310",
      hours: "Mon-Fri 9:00 AM - 4:30 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Carthage (southeast of Watertown)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Carthage and southern Jefferson County residents.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Watertown?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Watertown residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Watertown?",
      a: "The Watertown Main Post Office at 232 Washington Street is the major Watertown passport acceptance facility. The Fort Drum Post Office at 11030 Mount Belvedere Boulevard serves military families, and the Carthage Post Office at 525 State Street is available for southern Jefferson County residents.",
    },
    {
      q: "Can I get same-day passport photos in Watertown?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, and Rite Aid locations throughout Watertown, Fort Drum, and Jefferson County. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Watertown?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Watertown passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Watertown?",
      a: "The fastest way to renew a passport in Watertown is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Watertown?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Watertown and all Jefferson County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Watertown?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Watertown. We serve the Thousand Islands region and all of Jefferson County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Watertown", address: "various CVS locations across Watertown and Jefferson County", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Watertown", address: "various Walgreens locations throughout Watertown", hours: "Mon-Sun, hours vary by location" },
    { name: "Rite Aid — Watertown", address: "various Rite Aid locations in Watertown and Carthage", hours: "Mon-Sun, hours vary by location" },
    { name: "Walmart Photo Center — Watertown", address: "Walmart Supercenter, Watertown", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Watertown",
      address: "1001 Coffeen Street, Watertown, NY 13601",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Watertown DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Fort Drum",
      address: "On-post DMV services available at Fort Drum",
      hours: "Check base schedule for hours",
      note: "Fort Drum offers on-post DMV services for military personnel and dependents.",
      featured: false,
    },
    {
      name: "NYS DMV — Lowville",
      address: "7588 South State Street, Lowville, NY 13367",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Lowville DMV office serving eastern Jefferson County and Lewis County residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ART",
      name: "Watertown International Airport",
      distance: "In Watertown, NY",
      address: "2380 County Route 66, Dexter, NY 13634",
      note: "Watertown's primary airport with flights to major hubs including Philadelphia. Convenient for Thousand Islands and Fort Drum area travelers.",
      flightUrl: "https://www.watertownairport.com/",
      flightLabel: "ART Airport",
      featured: true,
    },
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "~75 miles from Watertown",
      address: "1000 Col Eileen Collins Blvd, Syracuse, NY 13212",
      note: "Major upstate New York airport with flights to major U.S. and international destinations. Alternative for Watertown area travelers.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "Syracuse Airport",
      featured: false,
    },
    {
      code: "ROC",
      name: "Greater Rochester International Airport",
      distance: "~130 miles from Watertown",
      address: "1200 Brooks Ave, Rochester, NY 14624",
      note: "Western New York airport with flights to major U.S. hubs. Alternative for Watertown travelers heading west.",
      flightUrl: "https://www.flyrga.com/",
      flightLabel: "Rochester Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Watertown travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Watertown residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Watertown residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Watertown residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Watertown, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Watertown residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Watertown travelers with immediate departure needs from Watertown International or Syracuse." },
    { name: "Passport Renewal", description: "Fast passport renewal for Watertown residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Watertown residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Watertown residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Watertown and Jefferson County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Watertown." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Watertown travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Watertown travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Watertown team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Watertown address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Saratoga Springs", route: "/cities/saratoga-springs" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Plattsburgh", route: "/cities/plattsburgh" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Malone", route: "/cities/malone" },
    { name: "Tupper Lake", route: "/cities/tupper-lake" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Watertown and all of the Thousand Islands region as a remote courier service. We do not have a physical office in Watertown, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Watertown area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Watertown and all of Jefferson County. From the Thousand Islands to Fort Drum, from Carthage to Sackets Harbor — we serve the North Country with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Watertown and all surrounding communities across Jefferson County and the Thousand Islands region. Whether you're at Fort Drum, in Carthage, or Adams, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Watertown customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Watertown travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Watertown travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Watertown. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default watertownConfig;